import { useContext } from 'react';
import { MyContext } from '../Store';
import { trans } from '../utils';

export const Header = () => {
  const [state] = useContext(MyContext);
  const { productData } = state;

  const productName = `${productData.name} ${productData.vendo_code.slice(0, -2)}`;

  return (
    <header className="header">
      <div className="header__title">
        {trans('Konfigurator produktu')} {productName}
      </div>
    </header>
  );
};
